// extracted by mini-css-extract-plugin
export default {"menu":"MenuDesktop_menu__HRv+2","ul":"MenuDesktop_ul__FQUky","list":"MenuDesktop_list__FNQCM","logo":"MenuDesktop_logo__OYJt0"};